module.exports = __webpack_public_path__ + "img/icon-monitoring.147379ce.svg";